var map = {
	"./basic/assets/languages/cn.json": 4868,
	"./cmbi/assets/languages/cn.json": 643,
	"./eif/assets/languages/cn.json": 28862,
	"./fubon/assets/languages/cn.json": 47262,
	"./scb/assets/languages/cn.json": 71806,
	"./ttl/assets/languages/cn.json": 5906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59113;